import axios from "axios";
import { toast } from "react-toastify";
export const GetAllRePurchasePopulate = (data) => {
  return {
    type: "get_allrepurchasepopulate",
    payload: data,
    loader: false,
  };
};
export function getallrepurchasepopulate() {
  return (dispatch) => {
    axios({
      url: `${process.env.REACT_APP_API_URL}UnitPurchase/Repurchase/Populate`,
      method: "Get",
      headers: {
        Authorization: `Bearer ${localStorage.getItem("token")}`,
        "content-type": "application/json",
      },
    }).then(
      (result) => {
        if (result.data.IsSuccess === true) {
          dispatch(GetAllRePurchasePopulate(result.data.Data));
        } else {
          toast.info(result.data.Message);
        }
      },
      (error) => {
        toast.info("Something went wrong!");
      }
    );
  };
}

export const GetAllRePurchaseTableData = (data) => {
  return {
    type: "get_repurchasetable",
    payload: data,
    loader: false,
  };
};
export function getallrepurchase() {
  return (dispatch) => {
    axios({
      url: `${process.env.REACT_APP_API_URL}UnitPurchase/GetAll/Old`,
      method: "Get",
      headers: {
        Authorization: `Bearer ${localStorage.getItem("token")}`,
        "content-type": "application/json",
      },
    }).then(
      (result) => {
        if (result.data.IsSuccess === true) {
          dispatch(GetAllRePurchaseTableData(result.data.Data));
        } else {
          toast.info(result.data.Message);
        }
      },
      (error) => {
        toast.info("Something went wrong!");
      }
    );
  };
}
